import React, { useEffect, useState } from "react";
import '../../assets/css/Profile.css';
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { apiHandler } from "../../assets/api/index";
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import Spinner from "../../components/Spinner";

const MembershipDetail = () => {
    const navigate = useNavigate();
    const { accessToken ,isOnBoarded} = useSelector((state) => state?.loginInfo.accessToken);
    const [membershipDetail, setMembershipDetail] = useState();
    const [subscriptionId, setSubscriptionId] = useState();
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState("");
    const [loader, setLoader] = useState();

    const cancelReasons = [
        "Found a better alternative",
        "Price is too high",
        "Not using the service anymore",
        "Technical issues / Bugs",
        "Lack of required features",
        "Too complicated to use",
        "Privacy or security concerns",
        "Temporary unsubscription (Might return later)",
        "Poor user experience or interface",
        "Other (Allow user to enter their reason manually)",
    ];

    useEffect(() => {
        const subscriptionPlan = async () => {
            setLoader(true);
            try {
                const result = await apiHandler({
                    url: endpoint.MEMBERSHIP_DETAIL,
                    method: "GET",
                    authToken: accessToken
                });
                setMembershipDetail(result?.data);
                setLoader(false)
                setSubscriptionId(result?.data?.[0]?.subscriptionId);
            } catch (error) {
                setLoader(true)
                toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
            }
        };
        subscriptionPlan();
    }, []);

    const onRenewSubscription = async () => {
        navigate('/subscription')
    };

    const onCancel = () => {
        setShowCancelModal(true);
    };

    const handleReasonChange = (reason) => {
        if (selectedReasons.includes(reason)) {
            setSelectedReasons(selectedReasons.filter(r => r !== reason));
        } else {
            setSelectedReasons([...selectedReasons, reason]);
        }
    };

    const handleReasonSubmit = async () => {
        const finalReasons = selectedReasons.includes("Other (Allow user to enter their reason manually)")
            ? [...selectedReasons.filter(r => r !== "Other (Allow user to enter their reason manually)"), otherReason]
            : selectedReasons;

        const queryParams = [
            `id=${subscriptionId}`,
            `reason=${encodeURIComponent(finalReasons.join(", "))}`
        ];

        const queryString = queryParams.join("&");

        try {
            const result = await apiHandler({
                url: `${endpoint.CANCEL_SUBSCRIPTION}?${queryString}`,
                method: "PUT",
                authToken: accessToken
            });

            setMembershipDetail(result?.data);
            toast.success("Your feedback has been submitted.");
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
        }

        setShowReasonModal(false);
        setSelectedReasons([]);
        setOtherReason("");
    };

console.log('isOnBoarded',isOnBoarded)
    return (
        <div className="d-flex justify-content-center p-4 pt-0 w-100" >
            <div className={`row w-100 ${membershipDetail?.length > 0 ? 'membership-wrapper' : 'no-membership-content'}`}>
                {!loader ? (
                    <>
                        {Array.isArray(membershipDetail) && membershipDetail?.length > 0 && (
                            <div className="row" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', background: 'white' ,borderRadius:'8px'}}>
                                <div className="col-lg-5 w-100">
                                    <h4 className=" w-100  ps-4 pt-4 mb-4 text-center" >Subscription Plan</h4>
                                </div>
                                {membershipDetail.map((item) => (
                                    <div key={item.subscriptionId} className="col-lg-12 mb-4">
                                        <div className=" ps-sm-4 pe-sm-4 pb-sm-4 rounded h-100">
                                            <div className="row">
                                                <div className="col-6 col-sm-3 col-lg-3 mb-3 text-center text-sm-start">
                                                    <p className="mb-1 text-muted membership-detail-title">Name</p>
                                                    <p className="mb-0 membership-detail-sub-title">{item.name}</p>
                                                </div>
                                                <div className="col-6 col-sm-3  col-lg-3 mb-3 text-center text-sm-start">
                                                    <p className="mb-1 text-muted membership-detail-title">Plan Type</p>
                                                    <p className="mb-0 membership-detail-sub-title">{item.plan}</p>
                                                </div>
                                                <div className="col-6 col-sm-3  col-lg-3 mb-3 text-center text-sm-start">
                                                    <p className="mb-1 text-muted membership-detail-title">Price</p>
                                                    <p className="mb-0 membership-detail-sub-title">${item.price}/month</p>
                                                </div>
                                                <div className="col-6 col-sm-3  col-lg-3 mb-3 text-center text-sm-start">
                                                    <p className="mb-1 text-muted membership-detail-title">Start Date</p>
                                                    <p className="mb-0 membership-detail-sub-title">
                                                        {new Date(item.startDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        })}
                                                    </p>
                                                </div>
                                                <div className="col-6 col-sm-3  col-lg-3 mb-3 text-center text-sm-start">
                                                    <p className="mb-1 text-muted membership-detail-title">End Date</p>
                                                    <p className="mb-0 membership-detail-sub-title">
                                                        {new Date(item.endDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        })}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-3  col-lg-3 mb-3 text-center text-sm-start">
                                                <p className="mb-0" style={{ color: '#55FF00' }}>{item.status == 'ACTIVE_SUB' ? 'Active Subscription' : ''}</p>
                                            </div>
                                            <div className="row ps-2 pe-2">
                                                <div className="col-12">
                                                    <p className="text-center text-muted mt-sm-4 py-sm-3 membership-subscription-text p-1 p-sm-0">
                                                        Your next renewal date is also your subscription end date.
                                                    </p>

                                                </div>
                                                <CustomButton
                                                buttonText={"Cancel"}
                                                className="border"
                                                style={{
                                                    width: "100%",
                                                    height: "48px",
                                                    borderRadius: "12px",
                                                    background: "#006FFD",
                                                    color: "#FFFFFF",
                                                }}
                                                onClick={onCancel}
                                            />
                                            </div>
                            
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {(membershipDetail?.length <= 0  ) &&
                            <>
                                <div className="row">
                                    <div className="col-12 d-grid">
                                        <CustomButton
                                            buttonText={"Renew Subscription"}
                                            className="border"
                                            style={{
                                                width: "100%",
                                                height: "48px",
                                                borderRadius: "12px",
                                                background: "#006FFD",
                                                color: "#FFFFFF",
                                            }}
                                            onClick={onRenewSubscription}
                                        />
                                    </div>
                                </div>
                            </>
                        }
                    </>
                ) : (
                    <Spinner />
                )}
            </div>

            {/* Cancel Confirmation Modal */}
            {showCancelModal && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ width: '500px' }}>
                        <p>Are you sure you want to cancel the subscription?</p>
                        <div className="d-flex justify-content-around mt-3">
                            <CustomButton
                                buttonText={"YES"}
                                className="border"
                                style={{
                                    width: "100px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    background: "#006FFD",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => { setShowCancelModal(false); setShowReasonModal(true); }}
                            />
                            <CustomButton
                                buttonText={"NO"}
                                className="border"
                                style={{
                                    width: "100px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    background: "#006FFD",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => setShowCancelModal(false)}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Reason Selection Modal */}
            {showReasonModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h5>Please tell us why you’re canceling:</h5>
                        {cancelReasons.map(reason => (
                            <div key={reason} className="form-check">
                                <label>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={selectedReasons.includes(reason)}
                                        onChange={() => handleReasonChange(reason)}
                                    /> {reason}
                                </label>
                            </div>
                        ))}
                        {selectedReasons.includes("Other (Allow user to enter their reason manually)") && (
                            <textarea
                                placeholder="Please specify..."
                                className="form-control mt-2"
                                value={otherReason}
                                onChange={(e) => setOtherReason(e.target.value)}
                            />
                        )}
                        <button className="btn btn-primary mt-3" onClick={handleReasonSubmit}>Submit</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MembershipDetail;
